import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';

import SearchForm from '../UI/SearchForm';
import Pagination from '../UI/Pagination';
import { getMenu } from '../../actions';


class CustomerMenu extends Component {

    componentDidMount() {
        this.props.getMenu(1, null);
    }

    onSubmitSearchHandler = searchValue => this.props.getMenu(1, searchValue);

    pageChangeHandler = page => this.props.getMenu(page.selected + 1, null);

    renderMenus = () => {
        let menus = null;
        if (this.props.data && this.props.data.menus && this.props.data.result) {
            menus = this.props.data.result.map(menuId => {
                const menu = this.props.data.menus[menuId];
                return (
                    <li className="card" key={menu.id}>
                        <div className="action">
                        </div>
                        <div className="inner">
                            <h2>{menu.name}</h2>
                        </div>
                        <div className="options text-center">
                            <Link to={"/menu/" + menuId + "/item"} className="pointer">View Lists</Link>
                        </div>
                    </li>
                );
            });
        }
        return menus;
    };

    render() {
        let pagination = null;
        if (this.props.data && this.props.data.pageCount && this.props.data.pageCount > 1) {
            pagination = <Pagination pageChangeHandler={ this.pageChangeHandler } pageCount={ this.props.data.pageCount }/>;
        }
        return (
            <React.Fragment>
                <div className="page-title">
                    <div className="container">
                        <div className="row flex-center-y justify-between">
                            <div className="col-xs-9 text-left">
                                <h1 className="color-grey">Menu Settings</h1>
                            </div>
                            <SearchForm  onSubmit={ this.onSubmitSearchHandler } />
                        </div>
                    </div>
                </div>

                <div className="container inner-padding box py-15">
                    <div className="box-body">
                        <ul className="card-items small">
                            { this.renderMenus() }
                        </ul>
                        { pagination }
                    </div>
                </div>

            </React.Fragment>
        );
    }
}

const mapStateToProps = state => {
    return {
        data: state.foodna
    }
};

export default connect(mapStateToProps, { getMenu })(CustomerMenu);



// WEBPACK FOOTER //
// ./src/components/Customer-web-portal/MenuSettings.js